import { render, staticRenderFns } from "./ContractWorkspaceReset.vue?vue&type=template&id=72e42bc0"
import script from "./ContractWorkspaceReset.vue?vue&type=script&lang=js"
export * from "./ContractWorkspaceReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports